/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Dropdown, Icon } from 'antd';
// $FlowFixMe
import { Button } from '@bijie/react-bnb';

import RateLists from './RateLists';

const StyledButton = styled(Button)`
  border-radius: 18px;
  border-color: #e6e6e6;
  width: 80px;
`;

const MenuBox = styled.div`
  background: #fff;
`;

export const getNativeCurrency = (userPreferredCurrency: Object) => {
  if (!userPreferredCurrency) return 'USD';
  /* eslint-disable-next-line */
  return (
    userPreferredCurrency &&
    userPreferredCurrency.configName &&
    userPreferredCurrency.configName.split('_')[0]
  );
};

type Props = {
  userPreferredCurrency: Object,
  trigger: Array<string>,
};

const mapStateToProps = ({ userPreferredCurrency }) => ({
  userPreferredCurrency,
});

export default
@connect(mapStateToProps)
class RateSwitch extends React.Component<Props> {
  static defaultProps = {
    userPreferredCurrency: {},
    trigger: ['click'],
  };

  render() {
    const { trigger, userPreferredCurrency } = this.props;
    const currencyName = getNativeCurrency(userPreferredCurrency);
    return (
      <Dropdown
        overlay={
          <MenuBox>
            <RateLists />
          </MenuBox>
        }
        trigger={trigger}
      >
        <StyledButton>
          {currencyName || 'USD'} <Icon type="down" />
        </StyledButton>
      </Dropdown>
    );
  }
}
